import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { getIsRecording, getIsSummarizing } from '~/store/duck/audioRecorder'
import { getAppointmentId } from '~/store/reducers/soap'

/**
 * Manages correlationId locking during active recording states.
 * Locks correlationId when recording starts, unlocks when session ends.
 *
 * @returns Locked correlationId if active, null otherwise
 */
export const useCorrelationIdLock = (): string | null => {
  const currentAppointmentId = useSelector(getAppointmentId)
  const isRecording = useSelector(getIsRecording)
  const isSummarizing = useSelector(getIsSummarizing)

  // Track the appointmentId when recording starts - keep it fixed during active states
  const [lockedCorrelationId, setLockedCorrelationId] = useState<string | null>(
    null,
  )

  // Lock correlationId when recording starts
  useEffect(() => {
    if (isRecording && currentAppointmentId && !lockedCorrelationId) {
      setLockedCorrelationId(currentAppointmentId)
    }
  }, [isRecording, currentAppointmentId, lockedCorrelationId])

  // Unlock when session ends (not recording, not summarizing, in safe state)
  useEffect(() => {
    if (!isRecording && !isSummarizing && lockedCorrelationId) {
      setLockedCorrelationId(null)
    }
  }, [isRecording, isSummarizing, lockedCorrelationId])

  return lockedCorrelationId
}
